import { render, staticRenderFns } from "./ConfiguracionCostos.vue?vue&type=template&id=49a042e3&"
import script from "./ConfiguracionCostos.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionCostos.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracionCostos.vue?vue&type=style&index=0&id=49a042e3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports